module.exports = __webpack_public_path__ + "static/media/typeBVersion1.a4020029.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hotspots/selfcare/typeBVersion1.png
// module id = 1254
// module chunks = 0